export const citiesOptions = [
  { label: 'Bangalore', value: 'Bangalore' },
  { label: 'Hyderabad', value: 'Hyderabad' },
  { label: 'Pune', value: 'Pune' },
  { label: 'Chennai', value: 'Chennai' },
  { label: 'Gurgaon', value: 'Gurgaon' },
  { label: 'Remote', value: 'Remote' },
  { label: 'Hybrid', value: 'Hybrid' },
  { label: 'Noida', value: 'Noida' },
  { label: 'Mumbai', value: 'Mumbai' },
  { label: 'Kolkata', value: 'Kolkata' },
  { label: 'Ahmedabad', value: 'Ahmedabad' },
  { label: 'Trivandrum', value: 'Trivandrum' },
  { label: 'Kochi', value: 'Kochi' },
  { label: 'Jaipur', value: 'Jaipur' },
  { label: 'Chandigarh', value: 'Chandigarh' },
  { label: 'Indore', value: 'Indore' },
  { label: 'Bhubaneswar', value: 'Bhubaneswar' },
  { label: 'Lucknow', value: 'Lucknow' },
  { label: 'Vizag', value: 'Vizag' },
  { label: 'Nagpur', value: 'Nagpur' },
  { label: 'Mysore', value: 'Mysore' },
  { label: 'Coimbatore', value: 'Coimbatore' },
  { label: 'Surat', value: 'Surat' },
  { label: 'Madurai', value: 'Madurai' },
  { label: 'Raipur', value: 'Raipur' },
  { label: 'Patna', value: 'Patna' },
  { label: 'Guwahati', value: 'Guwahati' },
  { label: 'Aurangabad', value: 'Aurangabad' },
  { label: 'Vadodara', value: 'Vadodara' },
  { label: 'Udaipur', value: 'Udaipur' },
  { label: 'Mangalore', value: 'Mangalore' },
  { label: 'Kanpur', value: 'Kanpur' },
  { label: 'Nashik', value: 'Nashik' },
  { label: 'Jabalpur', value: 'Jabalpur' },
  { label: 'Ranchi', value: 'Ranchi' },
  { label: 'Vijayawada', value: 'Vijayawada' },
  { label: 'Rajkot', value: 'Rajkot' },
  { label: 'Bhopal', value: 'Bhopal' },
  { label: 'Varanasi', value: 'Varanasi' },
  { label: 'Gwalior', value: 'Gwalior' },
  { label: 'Meerut', value: 'Meerut' },
  { label: 'Jodhpur', value: 'Jodhpur' }
];
